import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks/useAppSelector';
import RestroLiteLeadsPage from '../superAdmin/RestroLiteLeadsPage';

export default function EmployeeRestroLiteLeadsPage() {
  const { user } = useAppSelector((state) => state.auth);
  if (!user?.permissions?.tabs?.restroLiteLeads) {
    return <Navigate to="/employee/dashboard" replace />;
  }
  return <RestroLiteLeadsPage readOnlyEmployee />;
}
